module.exports = __webpack_public_path__ + "static/img/40010 (4).ad93e04.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40010 (4).webp
// module id = PmLN
// module chunks = 14